import apis from ".";
export async function getProductbyId(productId, token) {
  try {
    const result = await apis.get(
      `/product/get-product-detail-by-id?productId=${productId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return result;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
}

export async function getProductName(data, token) {
  try {
    const result = await apis.get(
      `/product/get-all-products-by-seller-id?sellerId=${data.sellerId
      }&perPage=${data.perPage}&page=${data.page + 1}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return result;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
}